import { render, staticRenderFns } from "./ArticleInlineSlider.vue?vue&type=template&id=6e8c369e"
import script from "./ArticleInlineSlider.vue?vue&type=script&lang=js"
export * from "./ArticleInlineSlider.vue?vue&type=script&lang=js"
import "./ArticleInlineSlider.vue?vue&type=style&index=0&id=6e8c369e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports